<template>
	<div class="mainWrapper po">
		<h1>Purchase Orders</h1>

		<div class="links">
			<b-button type="is-info"
				><router-link to="/export/po">
					Export PO
				</router-link></b-button
			>
		</div>

		<div class="general-search">
			<div>
				<b-field>
					<b-input v-model="searchPOCode" placeholder="PO Code" @keyup.native.enter="searchPO"></b-input>
				</b-field>
			</div>

			<div>
				<b-button type="is-info" @click="searchPO()" icon-left="magnify">Search</b-button>
			</div>
		</div>

		<div class="list" v-if="list">
			<div class="poList header">
				<div>PO CODE</div>
				<div>BRAND</div>
				<div>SHOP</div>
				<div>STATUS</div>
				<div>CREATED DATE</div>

				<div></div>
			</div>

			<div v-for="(item, index) of list" v-bind:key="index" class="poList">
				<div>{{ item.code }}</div>
				<div>{{ item.brand.name }}</div>
				<div>{{ item.shop.name }}</div>
				<div>
					<div :class="getStatusClass(item)">
						{{ piStatus(item) }}
					</div>
				</div>
				<div>{{ convertTime(item.createdAt) }}</div>
				<div @click="viewPODetail(item._id)" class="hyperlink">
					<ios-arrow-forward-icon w="32px" h="32px" />
				</div>
			</div>

			<paginate
				v-model="page"
				:page-count="pageCount"
				:click-handler="pagerClick"
				:prev-text="'prev'"
				:next-text="'next'"
				:container-class="'pagination'"
			>
			</paginate>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PurchaseOrder',
	data: function() {
		return {
			limit: this.$config.pageItemsLimit, // For pager
			list: null, // Will contain all the list
			pageCount: 1, // For pager
			page: 1, // For pager
			searchPOCode: null
		}
	},

	mounted: async function() {
		if (this.$route.params.page == undefined) {
			this.page = 1
		}

		// Get all the PO
		var data = {
			limit: this.limit,
			populate: ['author', 'supplier', 'shop', 'brand']
		}

		const apiGetPO = await this.$api.getPO({ data })
		this.pageCount = Math.ceil(apiGetPO.data.total / this.limit)
		this.list = apiGetPO.data.list
	},

	methods: {
		getStatusClass: function(item) {
			if (item.status) {
				return 'opened'
			} else {
				return 'closed'
			}
		},

		piStatus: function(item) {
			if (item.disable) {
				return 'DISABLED'
			}

			return item.status ? 'OPEN' : 'CLOSED'
		},

		// When user entered search
		searchPO: async function() {
			// Calculate how many items to skip

			var data = {
				limit: this.limit,
				populate: ['author', 'supplier', 'shop', 'brand']
			}

			if (this.searchPOCode && this.searchPOCode.length > 0) {
				data.code = this.searchPOCode
			}

			const apiGetPO = await this.$api.getPO({ data })
			this.pageCount = apiGetPO.data.total / this.limit
			this.list = apiGetPO.data.list
		},

		// When user click on page number
		pagerClick: async function(pageNumber) {
			// Calculate how many items to skip
			var skip

			if (pageNumber == 1) {
				skip = 0
			} else {
				skip = (pageNumber - 1) * this.limit
			}

			var data = {
				limit: this.limit,
				skip,
				populate: ['author', 'supplier', 'shop', 'brand']
			}

			if (this.searchPOCode && this.searchPOCode.length > 0) {
				data.code = this.searchPOCode
			}

			const apiGetPO = await this.$api.getPO({ data })
			this.pageCount = Math.ceil(apiGetPO.data.total / this.limit)
			this.list = apiGetPO.data.list
		},

		// Push to detail page
		viewPODetail: function(id) {
			// this.$router.push("/po/detail/" + id);
			this.$router.push({ name: 'poDetail', params: { id } })
		},

		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YY hh:mm a')
		}
	}
}
</script>

<style scoped>
@import '../styles/PO.css';
</style>
